import { HttpErrorResponse } from '@angular/common/http';
import { AuthErrorCode, RefreshOutcome } from 'src/app/infrastructure/model/AuthResponseDto';

export type { AuthErrorCode } from 'src/app/infrastructure/model/AuthResponseDto';

// Auth-Seiten (Login, Passwort, Registrierung), nicht aber z.B. «/authors»
const AUTH_ROUTE = /^\/auth(\/|\?|$)/;

/** Liegt die URL auf einer Auth-Seite? Dort nie auf den Login umleiten (keine Schleife). */
export function isAuthPage(url: string): boolean {
  return AUTH_ROUTE.test(url);
}

// Codes, mit denen das Backend eine 401 begründet: Zugriffs-Token (0.10) und Refresh-Fluss (OAuth Phase 1)
const AUTH_ERROR_CODES: readonly AuthErrorCode[] = [
  'TOKEN_EXPIRED', 'INVALID_TOKEN', 'TOKEN_REQUIRED',
  'REFRESH_EXPIRED', 'REFRESH_REUSED', 'REFRESH_MISSING', 'SESSION_REVOKED', 'USER_INACTIVE', 'LICENSE_EXPIRED',
];

// Fehlercode aus einer 401-Antwort des Backends (0.10). Ältere Backends liefern keinen Code → null.
export function authErrorCode(error: unknown): AuthErrorCode | null {
  if (!(error instanceof HttpErrorResponse) || error.status !== 401) return null;
  const body: unknown = error.error;
  if (typeof body !== 'object' || body === null || !('code' in body)) return null;
  const code = (body as { code: unknown }).code;
  return AUTH_ERROR_CODES.find((known) => known === code) ?? null;
}

/**
 * Meldung beim Beenden einer Sitzung (Konzept §7.6). Mit Refresh-Ergebnis: nach dessen Code/Grund; ohne (Legacy,
 * Wiederholung nach Refresh erneut 401): nach dem Code der 401-Antwort wie bisher.
 */
export function sessionEndAlertKey(error: unknown, outcome?: RefreshOutcome): string {
  if (outcome?.kind === 'auth') {
    switch (outcome.code) {
      case 'REFRESH_REUSED':
        return 'alert.session-reused';
      case 'SESSION_REVOKED':
        return outcome.reason === 'password_change' ? 'alert.password-changed-relogin' : 'alert.session-expired';
      case 'USER_INACTIVE':
        return 'alert.account-deactivated';
      case 'LICENSE_EXPIRED':
        return 'alert.license-expired';
      default:
        return 'alert.session-expired';
    }
  }
  if (outcome) return 'alert.session-expired';
  return authErrorCode(error) === 'TOKEN_EXPIRED' ? 'alert.session-expired' : 'alert.session-invalid';
}
